import React, { useState, useEffect } from "react";
import {
  View,
  TextInput,
  Text,
  SafeAreaView,
  KeyboardAvoidingView,
  ImageBackground,
  TouchableOpacity,
  Dimensions,
  Platform,
  ActivityIndicator
} from "react-native";
import { useNavigation } from "@react-navigation/native";

import { useAuth } from "../hooks/useAuth";
import {authApi, sendOTP} from '../services/apiCall';

const windowWidth = Dimensions.get("window").width;
const windowHeight = Dimensions.get("window").height;

const Login = ({setIsAuthenticated}) => {
  // const route = useRouter();
  const {login} = useAuth();
  const navigation = useNavigation();
  const [error, setError] = useState(null);
  const [phoneNo, setPhoneNo] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const callLoginApi = async (mob, otp) => {
    setIsLoading(true)
    try {
      const response = await authApi(mob, otp);
      setIsLoading(false)
      return response?.data;
    } catch (error) {
      setIsLoading(false)
      console.error("Error calling login API:", error);
      return null;
    }
  };
  
  const handleLogin = async () => {
    const userData = await callLoginApi(phoneNo, enteredOtp);
    console.log(userData,'userDatauserData->')
    if (userData) {
      const response = {
        id: userData.id,
        name: userData.name,
        phoneNumber: userData.mobile,
        authToken: userData.token,
        birthDate:userData.birth_date,
        birthPlace: userData.birth_place,
        birthTime: userData.birth_date,
        gender: userData?.gender,
        profileImage: userData?.profile_image,
        firstTime:userData?.first_time,
        userBalance: userData?.coins,
      };
      login(response,()=>setIsAuthenticated(true));
      
    } else {
      console.error("Failed to log in, no user data received.");
    }
  };

  const onPhoneNumberChange = (number) => {
    setPhoneNo(number);
  };
  const onOTPChange = (number) => {
    setEnteredOtp(number);
  };

  const onGetOtpCalled = (type) => {
    if (type === "GET OTP") {
      sendOTP(phoneNo);
      setShowOtp(true);
    } else {
      handleLogin();
    }
  };

  const headerText = !showOtp ? "Mobile Number" : "Enter OTP";
  const loginBtnText = !showOtp ? "GET OTP" : "Continue";

  // return <Text>{JSON.stringify(uc.user)}</Text>;

  return (
    <SafeAreaView style={{ flex: 1,backgroundColor:'#f9f8f7' }}>
      <ImageBackground
        style={{
          flex: 1,
          height: windowHeight-20,
          width: windowWidth,
        }}
        resizeMode="contain"
        source={require("../../assets/LoginScreen.png")}
      >
        <KeyboardAvoidingView
          behavior={Platform.OS === "ios" ? "padding" : "height"}
          style={{ flex: 1 }}
          keyboardVerticalOffset={Platform.OS === "ios" ? 64 : 0}
        >
          <View style={{ flex: 1, justifyContent: "center" }}>
            <Text
              style={[
                styles.phoneInputTitle,
                { marginTop: windowHeight * 0.4 },
              ]}
            >
              {headerText}
            </Text>
            <View
              style={[
                styles.inputcontainer,
                !showOtp && {
                  borderBottomColor: "white",
                  borderBottomWidth: 2,
                },
                Platform.OS === 'web' && {backgroundColor:'white'},
                Platform.OS === 'android' && {justifyContent:'center'}
              ]}
            >
              {!showOtp ? (
                <View style={styles.phoneField}>
                  <Text style={styles.countryCode}>+91</Text>
                  <TextInput
                    keyboardType="number-pad"
                    placeholder=""
                    placeholderTextColor="white"
                    onChangeText={onPhoneNumberChange}
                    style={styles.phoneInput}
                    value={phoneNo}
                    maxLength={10}
                  />
                </View>
              ) : (
                <View style={styles.phoneField}>
                  <TextInput
                    keyboardType="number-pad"
                    placeholder=""
                    placeholderTextColor="white"
                    onChangeText={onOTPChange}
                    style={styles.phoneInput}
                    value={enteredOtp}
                    maxLength={6}
                  />
                </View>
              )}
            </View>
            <View style={{ justifyContent: "center", alignItems: "center" }}>
              <TouchableOpacity
                style={[
                  styles.otpButton,
                  (loginBtnText !== "GET OTP"
                    ? phoneNo.length === 10 && enteredOtp.length === 6
                    : phoneNo.length === 10) && { backgroundColor: "#269C19" },
                ]}
                onPress={() => {
                  onGetOtpCalled(loginBtnText);
                }}
                disabled={loginBtnText === 'GET OTP' ? phoneNo.length !== 10 : enteredOtp.length !== 6}
              >
              {isLoading ? (
                    <ActivityIndicator size="small" color="#000" />
                  ):( <Text style={styles.otpButtonText}>{loginBtnText}</Text>)}
              </TouchableOpacity>
            </View>
          </View>
        </KeyboardAvoidingView>
      </ImageBackground>
    </SafeAreaView>
  );
};

const styles = {
  phoneInputTitle: {
    color: "#000",
    fontSize: 20,
    textAlign: "left",
    marginHorizontal: 30,
    letterSpacing: 1,
    fontWeight: "400",
  },
  inputcontainer: {
    flexDirection: "row",
    alignItems: "center",
    // justifyContent: "center",
    marginTop: 10,
    marginHorizontal: 30,
    
  },
  phoneField: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: 5,
  },
  countryCode: {
    marginRight: 10,
    fontSize: 18,
    color: "#000",
    paddingLeft: 10,
  },
  phoneInput: {
    flex: 1,
    height: 40,
    fontSize: 18,
    color: "#000",
    width: "100%",
  },
  otpInputView: {
    width: "100%",
    height: 50,
  },
  otpButton: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "gray",
    width: "30%",
    padding: 10,
    borderRadius: 20,
    marginTop: 30,
  },
  otpButtonText: {
    color: "white",
    textAlign: "center",
    fontWeight: "600",
  },
  underlineStyleBase: {
    width: 45,
    height: 45,
    borderWidth: 1,
    borderBottomWidth: 1,
    color: "white",
    fontSize: 20,
  },
  underlineStyleHighLighted: {
    borderColor: "#03DAC6",
  },
};

export default Login;
